import { render, staticRenderFns } from "./OpenInAppBanner.vue?vue&type=template&id=5c95020e&scoped=true"
import script from "./OpenInAppBanner.vue?vue&type=script&lang=js"
export * from "./OpenInAppBanner.vue?vue&type=script&lang=js"
import style0 from "./OpenInAppBanner.vue?vue&type=style&index=0&id=5c95020e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c95020e",
  null
  
)

export default component.exports